import { FormControlLabelProps, useRadioGroup } from '@mui/material'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import MuiRadio from '@mui/material/Radio'
import { styled } from '@mui/material/styles'
import { forwardRef, ReactNode, useRef } from 'react'
import { colors } from 'styles/theme'

type Props = Omit<FormControlLabelProps, 'control'> & {
  renderIcon?: () => ReactNode
}

const Radio = forwardRef((props: Props, ref) => {
  const { renderIcon, ...radioProps } = props
  const radioRef = useRef(null)

  const { value } = useRadioGroup()
  const checked = value === radioProps.value

  function handleClick() {
    radioRef.current.click()
  }

  return (
    <Container checked={checked} onClick={handleClick}>
      <FormControlLabel
        sx={{ p: 0, m: 0 }}
        ref={ref}
        inputRef={radioRef}
        {...radioProps}
        control={<MuiRadio sx={{ py: 0, pl: 0, pr: 1 }} />}
      />
      {renderIcon && renderIcon()}
    </Container>
  )
})

export default Radio

const Container = styled(Box)<{ checked: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px;
  border: 1px solid ${colors.gray[200]};
  border-radius: 4px;
  transition: border-color, background-color, 150ms;

  background-color: ${({ checked }) =>
    checked ? colors.purple[50] : colors.white};
  border-color: ${({ checked }) =>
    checked ? colors.purple[500] : colors.gray[300]};

  &:hover {
    cursor: pointer;
    border-color: ${({ checked }) =>
      checked ? colors.purple[500] : colors.gray[600]};
    background-color: ${({ checked }) =>
      checked ? colors.purple[50] : colors.gray[50]};
  }
`
